import React, {  useEffect } from 'react';
import { Table, Input, Select } from 'antd';
import "./Table.css"
import { useTranslation } from 'react-i18next';


function DataTable({ data, setActivePatientData, toggleAddReportModal }: any) {
  const { t, i18n } = useTranslation();


const expandedRowRender = (record: any) => {
  // console.log('REECORD: ', record);
  
  const columns: any = [
    { 
      title: '#', 
      dataIndex: 'index', 
      key: 'index',
      render: (text: any, record: any, index: number) => index + 1, 
    },
    { 
      title: `${t('lab.table_2.report_name')}`, 
      dataIndex: 'report_name', 
      key: 'report_name' 
    },
    {
      title: `${t('lab.table_2.date_uploaded')}`, 
      dataIndex: 'created_at', 
      key: 'created_at' 
    },
    { 
      title: `${t('lab.table_2.action')}`, 
      key: 'document_url', 
      dataIndex: "document_url",
      render: (text: any, record: any, index: number) => <a target='_blank' href={`${text}`}>View Report</a> },
  ];

  return <Table key={record.id}   className="custom-table" columns={columns} dataSource={record.reports.map((item: any, index: any) => ({ ...item, index: index + 1 }))} pagination={false} />;
};

    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        { 
          title: `${t('lab.table_1.patient_phone')}`, 
          dataIndex: 'phone', 
          key: 'phone',
          sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
        },
        { 
          title: `${t('lab.table_1.patient_status')}`, 
          dataIndex: 'patientExist', 
          key: 'patientExist' ,
          sorter: (a: any, b: any) => (a.patientExist ? 1 : -1) - (b.patientExist ? 1 : -1),
          render: (patientExist: boolean) => (patientExist ? 'Patient Has Registered' : 'Inactive'),
        },
        {  title: `${t('lab.table_1.date_created')}`,  dataIndex: 'created_at', key: 'created_at' },
        { title: `${t('lab.table_1.action')}`, key: 'operation', render: (text: any, record: any, index: number) => <a onClick={() => {
          setActivePatientData(record)
          toggleAddReportModal()
        }}>{`${t('lab.table_1.upload_new')}`}</a> },
      ];
  
      

    return (
        <Table
            columns={columns}
            expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;